// TODO Upon submission ensure that the cover start date is the same as the current date.
(function(angular, THF, window) {
    window.THF = window.THF || {};
    window.THF.Angular = window.THF.Angular || {};
    
    window.THF.Angular.JoinForm = angular.module('thfJoinForm', ['thfFilters', 'thfApi', 'ngSanitize', 'ngAnimate', 'ngDialog', 'ngTouch', 'ui.date', 'ui.mask', 'ui.bootstrap.tpls', 'ui.bootstrap.typeahead']);

    window.THF.Angular.JoinForm.config(['uiMask.ConfigProvider', function(uiMaskConfigProvider) {
        uiMaskConfigProvider.clearOnBlur(false);
    }]);
})(angular, THF, window);
